import type { TooltipContentProps } from 'recharts'

import { formatDay } from './carrierDaily'

/** Every visible carrier on the hovered day, largest count first. */
export function CarrierDailyTooltip({ active, payload, label }: TooltipContentProps) {
  if (!active || !payload.length) return null
  const items = [...payload].sort((a, b) => Number(b.value) - Number(a.value))
  return (
    <div className="border-ink-100 bg-surface rounded-lg border px-3 py-2 text-xs shadow-sm">
      <p className="text-ink-500 mb-1">{formatDay(String(label), true)}</p>
      {items.map((item) => (
        <div key={String(item.dataKey)} className="flex items-center gap-2">
          <span aria-hidden className="h-0.5 w-3 rounded-full" style={{ backgroundColor: item.color }} />
          <span className="font-semibold tabular-nums">{String(item.value)}</span>
          <span className="text-ink-500">{item.name}</span>
        </div>
      ))}
    </div>
  )
}
